export default "__VITE_ASSET__y4p91_S7__"